export const authConfig = {
    domain: 'https://paarampariyaa.kinde.com', // e.g. 'yourapp.kinde.com'
    clientId: 'cdcb75ee411641d5a19067c84a32bc74',
    redirectUri: 'https://paarampariyaa.com/cart',
    logoutRedirectUri: 'https://paarampariyaa.com/cart',
    //  redirectUri: 'http://localhost:3000/cart',
    // logoutRedirectUri: 'http://localhost:3000/cart',

  };